// Re-export from @lightwaves/image-optimizer package
export { imageLoader as default } from '@lightwaves/image-optimizer';